module.exports = __webpack_public_path__ + "static/media/table-padding-vertical.fbdd7111.png";